import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=3b5faf88"
import script from "./BannerSwiper.vue?vue&type=script&lang=ts"
export * from "./BannerSwiper.vue?vue&type=script&lang=ts"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=3b5faf88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports